import { useDroppable } from '@dnd-kit/core'
import { Background, ReactFlow } from '@xyflow/react';

export const EditorWindow = (props: any) => {
    const {isOver, setNodeRef} = useDroppable({
        id: 'editor-window'
    });

    return (
        <div style={{flex: 1}} ref={setNodeRef}>
            <ReactFlow nodes={props.nodes} edges={props.edges}>
            <Background />
            </ReactFlow>
        </div>
    )
}